import { createSlice } from "@reduxjs/toolkit";
import { fetchIssuePacking } from "./thunk";

interface IssuePackingState {
  IssuePackingList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: IssuePackingState = {
  IssuePackingList: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const IssuePackingSlice = createSlice({
  name: "IssuePacking",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchIssuePacking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIssuePacking.fulfilled, (state, action) => {
        state.loading = false;
        state.IssuePackingList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchIssuePacking.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to fetch FieldEngineerList Log";
      });
  },
});

export default IssuePackingSlice.reducer;
